import cx from 'classnames';
import React, { ChangeEvent } from 'react';

import s from './switch.module.css';

export type SwitchBaseProps = {
    id: string;
    checked: boolean;
    value: number;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    title?: string | JSX.Element;
    labelPositionEnd?: boolean;
};

export type SwitchProps = Omit<React.HTMLAttributes<HTMLDivElement>, keyof SwitchBaseProps> &
    SwitchBaseProps;

const Switch = ({
    id,
    title,
    checked,
    value,
    onChange,
    labelPositionEnd = false,
    ...props
}: SwitchProps): JSX.Element => (
    <div {...props}>
        <input
            type="checkbox"
            id={id}
            name={id}
            className={s.switch}
            checked={checked}
            onChange={onChange}
            value={value}
        />
        {title && (
            <label htmlFor={id} className={cx(s.label, { [s.reverse]: labelPositionEnd })}>
                {title}
            </label>
        )}
    </div>
);

export default Switch;
